import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { SharedService, ClassService } from './_services';
@Component({
    selector: 'body',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    title = 'app';
    static globalBodyClass: string =
    'm-page--loading-non-block m-page--wide m-header--fixed ' +
    'm-header--fixed-mobile m-aside-left--enabled m-aside-left--offcanvas ' +
    'm-footer--push m-aside--offcanvas-default';
    isLoading: boolean;
    constructor(private _router: Router,
        private _sharedService: SharedService,
        private _classService: ClassService) {
        _sharedService.loadEmitted$.subscribe(
            enable => { setTimeout(() => { this.isLoading = enable; }, 200); });
    }

    ngOnInit() {
        this._router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                this._sharedService.emitLoad(true);
                this._classService.setClass(document.body, AppComponent.globalBodyClass);
            }
            if (route instanceof NavigationEnd) {
                this._sharedService.emitLoad(false);
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/app.component.ts